import React, { useState } from "react";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import asimg from "../../assets/images/asimg.png";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Link } from "react-router-dom"; //Link
const formSteps = [
  {
    question: "What type of care do you need?",
    description:
      "This helps us to assign the right nurse and prepare better care for you.",
    options: [
      {
        title: "Injection Assistance",
        desc: "Professional help for injections at home",
        icon: "💉",
      },
      {
        title: "Wound Dressing",
        desc: "Care for cuts, wounds and dressing changes",
        icon: "🩹",
      },
      {
        title: "Elderly Care",
        desc: "Personal care & support for seniors at home",
        icon: "👵",
      },
      {
        title: "Medical Support",
        desc: "Health monitoring and nursing support",
        icon: "🏥",
      },
    ],
  },
  {
    question: "How frequently do you need care?",
    description: "Choose a schedule that fits your requirements.",
    options: [
      {
        title: "One Time",
        desc: "Single visit service",
        icon: "1️⃣",
      },
      {
        title: "Daily",
        desc: "Regular daily care",
        icon: "📅",
      },
      {
        title: "Weekly",
        desc: "Weekly support",
        icon: "🗓️",
      },
      {
        title: "Monthly",
        desc: "Monthly visits",
        icon: "📆",
      },
    ],
  },
  {
    question: "Patient Details",
    description: "Provide basic patient information.",
    options: [
      {
        title: "Injection Assistance",
        desc: "Professional help for injections at home",
        icon: "💉",
      },
      {
        title: "Wound Dressing",
        desc: "Care for cuts, wounds and dressing changes",
        icon: "🩹",
      },
      {
        title: "Elderly Care",
        desc: "Personal care & support for seniors at home",
        icon: "👵",
      },
      {
        title: "Medical Support",
        desc: "Health monitoring and nursing support",
        icon: "🏥",
      },
    ],
  },
  {
    question: "Address Details",
    description: "Where should our team visit?",
    options: [
      {
        title: "Injection Assistance",
        desc: "Professional help for injections at home",
        icon: "💉",
      },
      {
        title: "Wound Dressing",
        desc: "Care for cuts, wounds and dressing changes",
        icon: "🩹",
      },
      {
        title: "Elderly Care",
        desc: "Personal care & support for seniors at home",
        icon: "👵",
      },
      {
        title: "Medical Support",
        desc: "Health monitoring and nursing support",
        icon: "🏥",
      },
    ],
  },
  {
    question: "Confirmation",
    description: "Review and submit your request.",
    options: [
      {
        title: "Injection Assistance",
        desc: "Professional help for injections at home",
        icon: "💉",
      },
      {
        title: "Wound Dressing",
        desc: "Care for cuts, wounds and dressing changes",
        icon: "🩹",
      },
      {
        title: "Elderly Care",
        desc: "Personal care & support for seniors at home",
        icon: "👵",
      },
      {
        title: "Medical Support",
        desc: "Health monitoring and nursing support",
        icon: "🏥",
      },
    ],
  },
];

export default function NursingAssesment() {
  const [currentStep, setCurrentStep] = useState(1);

  const [selectedOption, setSelectedOption] = useState("");

  const nextStep = () => {
    if (currentStep < formSteps.length) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const stepData = formSteps[currentStep - 1];

  return (
    <>
      <Header />
      <div className="assessment">
        <div className="container">
          <div className="stepper-wrapper">
            {/* Top Stepper */}

            <div className="stepper-header">
              <p className="short-title">ICU Setup Assessment</p>

              <div className="stepper-progress">
                {formSteps.map((_, index) => (
                  <div key={index} className="step-item">
                    <div
                      className={`step-circle 
                  ${index + 1 < currentStep ? "completed" : ""}
                  ${index + 1 === currentStep ? "active" : ""}`}
                    >
                      {index + 1 < currentStep ? (
                        <DoneOutlinedIcon />
                      ) : (
                        `0${index + 1}`
                      )}
                    </div>

                    {index !== formSteps.length - 1 && (
                      <div
                        className={`step-line ${
                          index + 1 < currentStep ? "filled" : ""
                        }`}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Content */}

            <div className="stepper-body">
              <div className="row align-items-center">
                <div className="col-lg-7">
                  <h2>
                    Q.{currentStep} {stepData.question}
                  </h2>

                  <p className="step-desc">{stepData.description}</p>
                </div>

                <div className="col-lg-5 text-center">
                  <img src={asimg} alt="" className="ass-img" />
                </div>
              </div>

              {/* Options */}

              {stepData.options.length > 0 && (
                <div className="options-grid">
                  {stepData.options.map((option, index) => (
                    <label
                      key={index}
                      className={`option-card ${
                        selectedOption === option.title ? "selected" : ""
                      }`}
                    >
                      <div className="option-icon">{option.icon}</div>

                      <div className="option-content">
                        <h5>{option.title}</h5>
                        <p>{option.desc}</p>
                      </div>

                      <input
                        type="radio"
                        name={`step-${currentStep}`}
                        value={option.title}
                        checked={selectedOption === option.title}
                        onChange={() => setSelectedOption(option.title)}
                      />
                    </label>
                  ))}
                </div>
              )}

              {/* Buttons */}

              <div className="step-actions">
                <button
                  className="back-btn"
                  onClick={prevStep}
                  disabled={currentStep === 1}
                >
                  BACK
                </button>

                <button className="next-btn" onClick={nextStep}>
                  NEXT
                </button>
              </div>
            </div>
          </div>

          {/* <button className="next-btn nxt_pge_btn">
            <Link to="/nursinglongbooking"> Patient Information</Link>
          </button> */}
        </div>
      </div>
      <Footer />
    </>
  );
}
